/**
 * Load theme variables and global styles
 * creates GlobalStyles component
 *
 * @param {String} themeName - name of the theme to load, it should be located at src/themes
 * @return {Object} with theme and GlobalStyles component
 */
export default async function loadTheme(themeName) {
  const { theme, GlobalStyle } = await import(
    /* webpackChunkName: "[request]-theme" */
    /* webpackPreload: true */
    `../../themes/${themeName}`
  )

  return {
    theme,
    GlobalStyle
  }
}
